module.exports = __webpack_public_path__ + "img/silent-night-image.9e78c9ce.jpg";